'use client';

import type { PropsWithChildren, ReactNode } from 'react';

import type { QueryStringSchema } from '../../schema/input/entry.js';
import TipsenSheetClient from './TipsenSheetClient.js';

type SheetProps = PropsWithChildren<{
  sheet: QueryStringSchema['sheet'] | undefined;
  validSheets: QueryStringSchema['sheet'][];
  isLocked?: boolean;
  title: string;
  description: string;
  onOpenChange?: (isOpen: boolean) => void;
}>;

/**
 * Renders the sheet base.
 *
 * @param root0 SheetPageProps
 * @param root0.children the children to pass down
 * @param root0.isLocked Prevent closing when true (content loading)
 * @param root0.title Optional title shown in the sheet header
 * @param root0.description Optional screen-reader description for the sheet
 * @param root0.onOpenChange callback to run when sheet is opened/closed
 * @param root0.sheet Active sheet
 * @param root0.validSheets Sheets that are valid at a given time
 * @returns Sheet page component
 */
export default function TipsenSheet({
  sheet,
  validSheets,
  isLocked,
  title,
  description,
  onOpenChange,
  children,
}: SheetProps): ReactNode {
  const isOpen = validSheets.includes(sheet);

  return (
    <TipsenSheetClient
      isOpen={isOpen}
      isLocked={isLocked}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
    >
      {children}
    </TipsenSheetClient>
  );
}
